<template>
  <div class="common-page order-management">
    <div class="tab-box">
      <custom-tab-box :tabData="tabData" @change="handleChangeTab" :selectTab="selectTab"></custom-tab-box>
    </div>
    <div class="components-content">
      <freight-route-rules v-if="selectTab === 1"></freight-route-rules>
      <yfyjxs-config v-if="selectTab === 2"></yfyjxs-config>
      <dlsyyf-config v-if="selectTab === 3"></dlsyyf-config>
      <fwsglfbl-config v-if="selectTab === 4"></fwsglfbl-config>
    </div>
  </div>
</template>

<script>
import freightRouteRules from "./components/freightRouteRules";
import yfyjxsConfig from "./components/yfyjxsConfig";
import dlsyyfConfig from "./components/dlsyyfConfig";
import fwsglfblConfig from "./components/fwsglfblConfig.vue";
import CustomTabBox from "@/components/customComponents/CustomTabBox.vue";
export default {
  name: "ShipperManagement",
  components: {
    CustomTabBox,
    freightRouteRules,
    yfyjxsConfig,
    fwsglfblConfig,
    dlsyyfConfig,
  },
  data() {
    return {
      selectTab: 1,
      tabData: [
        {
          label: 1,
          value: "运费线路计算规则",
        },
        {
          label: 2,
          value: "运费溢价系数配置",
        },
        {
          label: 3,
          value: "代理商运营费配置",
        },
        {
          label: 4,
          value: "服务商管理费比例",
        },
      ],
    }
  },
  created() {},
  mounted() {

  },
  methods: {
    handleChangeTab(val) {
      this.selectTab = val
    }
  }
};
</script>
<style lang="scss" scoped>
.order-management {
  display: flex;
  flex-direction: column;
  .tab-box{
    padding: 16px 10px 0;
    flex-shrink: 0;
  }
  .components-content{
    flex: 1;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>
